import type { FC } from 'react'

interface NoteChange {
  isNew: boolean
  date: string
  title: string
  content: string | null
}

interface ExpensesSummary {
  count: number
  totalAmount: number
  currency: string
}

interface RecentChangesToastProps {
  notes: NoteChange[]
  expenses: ExpensesSummary | null
  careChangesCount: number
  onDismiss: () => void
}

const MAX_NOTES_SHOWN = 3

const RecentChangesToast: FC<RecentChangesToastProps> = ({
  notes,
  expenses,
  careChangesCount,
  onDismiss
}) => {
  const visibleNotes = notes.slice(0, MAX_NOTES_SHOWN)
  const hiddenNotesCount = notes.length - visibleNotes.length

  return (
    <div className="w-full max-w-sm bg-white border border-slate-200 rounded-lg shadow-lg p-4">
      <p className="font-semibold text-sm text-slate-800 mb-2">Ostatnie zmiany:</p>

      {/* Notes - full details */}
      {visibleNotes.map((note, i) => (
        <div key={i} className="mb-2 text-sm">
          <p className="text-slate-700">
            <span className="font-medium">
              {note.isNew ? 'Nowa notatka' : 'Zmieniona notatka'} ({note.date}):
            </span>{' '}
            {note.title}
          </p>
          {note.content && (
            <p className="text-slate-500 text-xs mt-0.5 line-clamp-2">{note.content}</p>
          )}
        </div>
      ))}
      {hiddenNotesCount > 0 && (
        <p className="text-xs text-slate-400 mb-2">
          ...i {hiddenNotesCount} {hiddenNotesCount === 1 ? 'kolejna notatka' : hiddenNotesCount < 5 ? 'kolejne notatki' : 'kolejnych notatek'}
        </p>
      )}

      {/* Expenses - summary */}
      {expenses && (
        <p className="text-sm text-slate-700 mb-1">
          Dodano {expenses.count} {expenses.count === 1 ? 'koszt' : expenses.count < 5 ? 'koszty' : 'kosztów'} (łącznie {expenses.totalAmount.toFixed(2)} {expenses.currency})
        </p>
      )}

      {/* Care changes - summary */}
      {careChangesCount > 0 && (
        <p className="text-sm text-slate-700 mb-1">
          Zmieniono {careChangesCount} {careChangesCount === 1 ? 'dzień' : careChangesCount < 5 ? 'dni' : 'dni'} opieki
        </p>
      )}

      <button
        onClick={onDismiss}
        className="mt-2 w-full px-3 py-1.5 text-sm font-medium rounded-md bg-blue-500 text-white hover:bg-blue-600 transition-colors"
      >
        OK
      </button>
    </div>
  )
}

export default RecentChangesToast
